import { DeleteOutlined, LockOutlined, UnlockOutlined } from '@ant-design/icons'
import { Button, Col, Form, InputNumber, Row } from 'antd'
import { Gutter } from 'antd/es/grid/row'
import TextArea from 'antd/es/input/TextArea'
import React, { FunctionComponent, useCallback, useMemo, useState } from 'react'

import { BUYBACK_FIELD as FIELD } from '../../../common/buybackTypes'
import { inputNumberFormatter } from '../../utils/buybackHelpers'

const gutter: Gutter | [Gutter, Gutter] = [8, 8]

export const BuybackFormDebtsFragment: FunctionComponent = () => {
  const [open, setOpen] = useState(false)

  const form = Form.useFormInstance()
  const debtFeeTotal = Form.useWatch(FIELD.DebtFeeTotal)
  const baseDebtFeeTotal = Form.useWatch(FIELD.BaseDebtFeeTotal) || 0

  const setCustomDebtFeeTotal = useCallback(() => {
    form.setFieldValue(FIELD.DebtFeeTotal, baseDebtFeeTotal)
    setOpen(true)
  }, [baseDebtFeeTotal, form])

  const resetCustomDebtFeeTotal = useCallback(() => {
    form.setFieldValue(FIELD.DebtFeeTotal, baseDebtFeeTotal)
    setOpen(false)
  }, [baseDebtFeeTotal, form])

  const isCustomDebtFeeTotal = useMemo(
    () => typeof debtFeeTotal === 'number' && debtFeeTotal !== baseDebtFeeTotal,
    [baseDebtFeeTotal, debtFeeTotal]
  )

  return (
    <Row gutter={gutter} align="middle" className="mt-4">
      <Col xs={20} md={13} xl={13}>
        <Form.Item name={FIELD.DebtAmountTotal} label="Celkový součet závazků">
          <InputNumber
            variant="filled"
            formatter={inputNumberFormatter}
            disabled
            addonAfter="Kč"
            className="!w-full !bg-gray-50"
          />
        </Form.Item>
      </Col>

      <Col xs={20} md={7} xl={8}>
        {isCustomDebtFeeTotal && (
          <div className="relative z-10 border-t border-gray-800 top-12 ml-2 w-16" />
        )}
        <Form.Item
          name={FIELD.BaseDebtFeeTotal}
          label="Součet odměn za vyřízení"
        >
          <InputNumber
            variant="filled"
            formatter={inputNumberFormatter}
            disabled
            addonAfter="Kč"
            className={isCustomDebtFeeTotal ? '!w-full' : '!w-full !bg-gray-50'}
          />
        </Form.Item>
      </Col>

      <Col xs={4} md={4} xl={3}>
        <Button
          block
          title="Individuální odměna"
          className="mt-2"
          disabled={isCustomDebtFeeTotal}
          icon={isCustomDebtFeeTotal ? <LockOutlined /> : <UnlockOutlined />}
          onClick={setCustomDebtFeeTotal}
        />
      </Col>

      <Col md={13} />

      <Col xs={24} md={11}>
        <Form.Item
          label="Individuální odměna za vyřízení"
          className="!mb-2"
          hidden={!isCustomDebtFeeTotal && !open}
        >
          <Row gutter={gutter}>
            <Col xs={20} md={18}>
              <Form.Item
                validateStatus="warning"
                className="!mb-0"
                name={FIELD.DebtFeeTotal}
              >
                <InputNumber
                  formatter={inputNumberFormatter}
                  addonAfter="Kč"
                  className="w-full"
                  min={0}
                  step={10000}
                />
              </Form.Item>
            </Col>
            <Col xs={4} md={6}>
              <Button
                block
                danger
                title="Použít standardní odměnu"
                icon={<DeleteOutlined />}
                onClick={resetCustomDebtFeeTotal}
              />
            </Col>
          </Row>
        </Form.Item>

        <Form.Item
          validateStatus="warning"
          hidden={!isCustomDebtFeeTotal}
          name={FIELD.DebtFeeNote}
          label={
            <span className="text-yellow-500">
              Nabídka podléhá schvalovacímu procesu
            </span>
          }
        >
          <TextArea
            rows={3}
            className="w-full"
            placeholder="Uveďte vysvětlení"
          />
        </Form.Item>
      </Col>
    </Row>
  )
}
